import { PayloadAction, createSlice } from "@reduxjs/toolkit";

const initialState: CountrySliceType = {
  countries: { count: 0, result: [] },
};

export const countrySlice = createSlice({
  name: "countries",
  initialState,
  reducers: {
    setCountries: (
      state: CountrySliceType,
      action: PayloadAction<PaginatedResonse<CountryType>>
    ) => {
      state.countries = action.payload;
    },
  },
});

export const { setCountries } = countrySlice.actions;
export default countrySlice.reducer;
